import React from "react";
import DeanPhoto from "../../images/Dean-Photo.jpeg";
import ArnelPhoto from "../../images/Arnel-Photo.jpeg";
import { getBotmarkCompanyDisplayName } from "../../utils/botmarkCompanyInfo";
import { useBotmarkCompanyInfo } from "../../hooks/useCompanies";
import "./Login.css";

function HomeAbout(){
    const { data: botmarkCompany } = useBotmarkCompanyInfo();
    const companyName = getBotmarkCompanyDisplayName(botmarkCompany);

    return(
        <div style={{ paddingBottom: "2rem", boxSizing: "border-box" }}>
            <h1 style={{textAlign:'left', marginLeft:"10%"}}>About Botmark</h1>
            <p style={{color:"darkgray", marginRight:"10%", marginLeft:"10%", marginBottom:"50px", textAlign:"left"}}>
                Our business began (1989) as a framing subcontractor, building multi- level apartments and Ag buildings with clear spans of 70’ and greater.
                <br/>
                <br/>
                {companyName} formerly Onchuck Construction has never strived to be big or above anyone else, we just believe in working hard and efficiently while caring for everyone and everything around us.
                <br/>
                <br/>
                We treasured our business for years with our small repetitive contractual hand shake customer base.
                <br/>
                <br/>
                Our company&#39;s size and efficiency has rewarded us with an ability to be innovative to develop new ideas for our business which have additionally contributed to our ability to be efficient adding to the quality of working standards all our employees could become part of.
                <br/>
                <br/>
                The expanded development, of our Plan processor and our Digital E-Ruler to perform robotic layouts (Botmark), for use by all contractors, is now our main business venture. Our company wishes our success to all as we deliver and share the benefits of our development to the entire construction industry.
            </p>
            <h3 style={{textAlign:'left', marginLeft:"10%"}}>Meet the Team</h3>
            <div className="aboutDiv" style={{display:"flex", width:"75%", marginLeft:"10%", marginBottom:"20px"}}>
                <img style={{width:"196px", height:"300px", border: "solid darkgray 2px", borderRadius:"5px", boxShadow:" 1px 4px 8px rgba(0, 0, 0, 0.2)"}} src={DeanPhoto}/>
                <div style={{display:"flex", flexDirection:"column", marginLeft: "20px", justifyContent:"end"}}>
                    <h3 style={{textAlign:"Left", margin:"0px"}}>Dean Onchuck</h3>
                    <h4 style={{color:"darkgrey", textAlign:"Left", margin:"0px", marginTop:"5px"}}>PRESIDENT</h4>
                    <p style={{margin:"", textAlign:"left"}}>
                        We all work everyday putting forward the best we can do with what we have. In business we all exist in this same environment.
                        <br/>
                        Changing methods to suit tomorrow is a real and difficult element in this industry.
                        <br/>
                        I have learned to teach within our methods that it is not about us being right or wrong with what we did yesterday, it is about us experiencing with our eyes open in our current environment to recognize there is always a path to a better way.
                    </p>
                </div>
            </div>
            <div className="aboutDiv" style={{display:"flex", width:"75%", marginLeft:"10%", marginBottom:"20px"}}>
                <img style={{width:"196px", height:"300px", border: "solid darkgray 2px", borderRadius:"5px", boxShadow:" 1px 4px 8px rgba(0, 0, 0, 0.2)"}} src={ArnelPhoto}/>
                <div style={{display:"flex", flexDirection:"column", marginLeft: "20px", justifyContent:"end"}}>
                    <h3 style={{textAlign:"Left", margin:"0px"}}>Arnel Onchuck</h3>
                    <h4 style={{color:"darkgrey", textAlign:"Left", margin:"0px", marginTop:"5px"}}>VICE PRESIDENT</h4>
                    <p style={{margin:"", textAlign:"left"}}>
                        It is exciting and challenging to be in business.
                        <br/>
                        I love working with people and helping them become more productive and in the same manner I learn from the experience of the people I work with.
                        The need never ends to learn of new products and methods to work with.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default HomeAbout;